<template>
  <div
    :class="
      cn('min-md:mt-auto min-md:p-5 flex flex-col justify-center gap-2 bg-neutral-100 p-5', props.class)
    "
    aria-labelledby="important-to-know-title"
    role="region"
  >
    <h3 class="text-sm font-semibold" id="important-to-know-title">
      {{ tg("disclaimer.title") }}
    </h3>

    <!-- Important To Know -->
    <ul
      class="marker:text-xxs list-inside list-disc marker:leading-normal"
      aria-label="Important information list"
    >
      <li
        class="text-primary/75 list-item gap-1 text-sm font-light"
        v-for="(disclaimer, index) in getDisclaimerList"
        :key="index"
      >
        {{ disclaimer }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
}>()

const { tg } = useI18nUtils({ useScope: "local" })

const getDisclaimerList = computed(() => tg("disclaimer.descriptions"))
</script>

<style lang="scss" scoped></style>

<i18n lang="json">
{
  "he": {
    "disclaimer": {
      "title": { "male": "חשוב שתדע", "female": "חשוב שתדעי" },
      "descriptions": {
        "male": [
          "אנחנו נצטרך את פרטי האשראי שלך למקרה שתבחרי רק לקבל את ההמלצות ולממש אותן בעצמך.",
          "התשלום יגבה רק לאחר 30 ימים ממועד הצגת ההמלצות, ואנו נזכיר לך שלושה ימים לפני.",
          "אם תבחר למנות אותנו כסוכנות הביטוח הפנסיונית שלך במהלך 30 הימים האמורים לא תצטרך לשלם עבור ההמלצות שהוכנו עבורך, ואנחנו לא נחייב את כרטיס האשראי שלך.",
          "אם לאחר 30 הימים האמורים תרצה לקבל המלצות חדשות (שירות שיווק פנסיוני) הוא יחשב כשירות חדש ויחולו עליו אותם התנאים."
        ],
        "female": [
          "אנחנו נצטרך את פרטי האשראי שלך למקרה שתבחרי רק לקבל את ההמלצות ולממש אותן בעצמך.",
          "התשלום יגבה רק לאחר 30 ימים ממועד הצגת ההמלצות, ואנו נזכיר לך שלושה ימים לפני.",
          "אם תבחרי למנות אותנו כסוכנות הביטוח הפנסיונית שלך במהלך 30 הימים האמורים לא תצטרכי לשלם עבור ההמלצות שהוכנו עבורך, ואנחנו לא נחייב את כרטיס האשראי שלך.",
          "אם לאחר 30 הימים האמורים תרצי לקבל המלצות חדשות (שירות שיווק פנסיוני) הוא יחשב כשירות חדש ויחולו עליו אותם התנאים."
        ]
      }
    }
  },
  "en": {}
}
</i18n>
